import Constants from '../../../constants/column-name/column-name.constants';

export default {
  Comment: {
    store: 'Comment',
    lookups: {
      idField: Constants.Comment.commentId.field,
      codeField: Constants.Comment.commentCode.field,
      nameField: Constants.Comment.commentText.field
    },
    formProps: {
      idField: Constants.OilSample.commentId.field,
      codeField: Constants.OilSample.commentId.field,
      nameField: Constants.OilSample.comments.field
    },
    optionLabelProp: Constants.Comment.commentCode.field,
    otherMappedProps: {
      isBadSample: Constants.Comment.isBad.field
    }
  },
  Customer: {
    store: 'Customer',
    lookups: {
      idField: Constants.Customer.customerId.field,
      codeField: Constants.Customer.customerCode.field,
      nameField: Constants.Customer.customerName.field,
      searchField: Constants.Customer.customerSearchField.field
    },
    formProps: {
      idField: Constants.OilSample.customerId.field,
      codeField: Constants.OilSample.customerCode.field,
      nameField: Constants.OilSample.customerName.field
    },
    optionLabelProp: Constants.OilSample.commentId.field,
    infoField: Constants.OilSample.customerInfoComments.field,
    otherMappedProps: {
      [Constants.Customer.allReportEmails.field]: Constants.Customer.allReportEmails.field,
      [Constants.Customer.goodReportEmails.field]: Constants.Customer.goodReportEmails.field,
      [Constants.Customer.badReportEmails.field]: Constants.Customer.badReportEmails.field,
      [Constants.Customer.email.field]: Constants.Customer.email.field,
      [Constants.OilSample.billingThirdParty.field]: Constants.Customer.customerThirdParty.field,
      [Constants.OilSample.customerInfoComments.field]: Constants.Customer.comments.field
    },
    childStore: 'Unit',
    childSearchKey: 'CustomerIdQuery',
    getSelectedItemServerSide: true,
    isServerSide: true,
    serverSearchKey: 'CustomerSearchFieldQuery',
    serverIdKey: 'CustomerIdQuery',
    serverIdOperator: 'CustomerIdOperator'
  },
  Fluid: {
    store: 'Fluid',
    lookups: {
      idField: Constants.Fluid.fluidId.field,
      codeField: Constants.Fluid.fluidKeywords.field,
      nameField: Constants.Fluid.fluidSearchField.field,
      searchField: Constants.Fluid.fluidSearchField.field
    },
    formProps: {
      idField: Constants.OilSample.fluidId.field,
      codeField: Constants.OilSample.fluidKeywords.field,
      nameField: Constants.OilSample.fluidSearchField.field
    },
    isServerSide: true,
    serverSearchKey: 'FluidSearchFieldQuery',
    searchOnOpen: true
  },
  FluidManufacturer: {
    store: 'FluidManufacturer',
    lookups: {
      idField: Constants.FluidManufacturer.fluidManufacturerID.field,
      codeField: Constants.FluidManufacturer.fluidManufacturerID.field,
      nameField: Constants.FluidManufacturer.fluidManufacturerName.field,
      searchField: Constants.FluidManufacturer.fluidManufacturerName.field
    },
    formProps: {
      idField: Constants.FluidManufacturer.fluidManufacturerID.field,
      codeField: Constants.FluidManufacturer.fluidManufacturerID.field,
      nameField: Constants.FluidManufacturer.fluidManufacturerName.field
    },
    isServerSide: true,
    serverSearchKey: 'FluidManufacturerSearchFieldQuery',
    searchOnOpen: true
  },
  FluidBrand: {
    store: 'FluidBrand',
    lookups: {
      idField: Constants.FluidBrand.fluidBrandID.field,
      codeField: Constants.FluidBrand.fluidBrandID.field,
      nameField: Constants.FluidBrand.fluidBrandName.field,
      searchField: Constants.FluidBrand.fluidBrandName.field
    },
    formProps: {
      idField: Constants.FluidBrand.fluidBrandID.field,
      codeField: Constants.FluidBrand.fluidBrandID.field,
      nameField: Constants.FluidBrand.fluidBrandName.field
    },
    isServerSide: true,
    serverSearchKey: 'FluidBrandSearchFieldQuery',
    searchOnOpen: true
  },
  FluidClass: {
    store: 'FluidClass',
    lookups: {
      idField: Constants.FluidClass.fluidClassID.field,
      codeField: Constants.FluidClass.fluidClassID.field,
      nameField: Constants.FluidClass.fluidClassName.field
    },
    formProps: {
      idField: Constants.FluidClass.fluidClassID.field,
      codeField: Constants.FluidClass.fluidClassID.field,
      nameField: Constants.FluidClass.fluidClass.field
    },
    isServerSide: true,
    serverSearchKey: 'FluidClassSearchFieldQuery',
    searchOnOpen: true
  },
  FluidWeight: {
    store: 'FluidWeight',
    lookups: {
      idField: Constants.FluidWeight.fluidWeightID.field,
      codeField: Constants.FluidWeight.fluidWeightID.field,
      nameField: Constants.FluidWeight.fluidWeightName.field,
      searchField: Constants.FluidWeight.fluidWeightName.field
    },
    formProps: {
      idField: Constants.FluidWeight.fluidWeightID.field,
      codeField: Constants.FluidWeight.fluidWeightID.field,
      nameField: Constants.FluidWeight.fluidWeightName.field
    },
    isServerSide: true,
    serverSearchKey: 'FluidWeightSearchFieldQuery',
    searchOnOpen: true
  },
  FluidBaselineSample: {
    store: 'FluidBaselineSample',
    lookups: {
      idField: Constants.FluidBaselineSample.fluidBaselineSampleID.field,
      codeField: Constants.FluidBaselineSample.fluidBaselineSampleID.field,
      nameField: Constants.FluidBaselineSample.fluidBaselineSampleNumber.field,
      searchField: Constants.FluidBaselineSample.fluidBaselineSampleNumber.field
    },
    formProps: {
      idField: Constants.FluidBaselineSample.fluidBaselineSampleID.field,
      codeField: Constants.FluidBaselineSample.fluidBaselineSampleID.field,
      nameField: Constants.FluidBaselineSample.fluidBaselineSampleNumber.field,
      searchField: Constants.FluidBaselineSample.fluidBaselineSampleNumber.field
    },
    otherMappedProps: {
      [Constants.FluidBaselineSample.fluidBaselineSampleDate.field]:
        Constants.FluidBaselineSample.fluidBaselineSampleDate.field
    },
    isServerSide: true,
    serverSearchKey: 'FluidSearchFieldQuery',
    searchOnOpen: true
  },
  FluidAction: {
    store: 'FluidAction',
    lookups: {
      idField: Constants.FluidAction.fluidActionId.field,
      codeField: Constants.FluidAction.fluidActionName.field,
      nameField: Constants.FluidAction.fluidActionName.field
    },
    formProps: {
      idField: Constants.OilSample.fluidActionId.field,
      codeField: Constants.OilSample.fluidActionName.field,
      nameField: Constants.OilSample.fluidActionName.field
    }
  },
  ManufacturerModel: {
    store: 'ManufacturerModel',
    lookups: {
      idField: Constants.ManufacturerModel.manufacturerModelName.field,
      codeField: Constants.ManufacturerModel.manufacturerModelName.field,
      nameField: Constants.ManufacturerModel.manufacturerModelName.field
    },
    formProps: {
      idField: 'manufacturerModelName',
      codeField: 'manufacturerModelName',
      nameField: 'manufacturerModelName'
    },
    isServerSide: true,
    serverSearchKey: 'ManufacturerModelSearchFieldQuery',
    searchOnOpen: true
  },
  ThirdParty: {
    store: 'ThirdParty',
    lookups: {
      idField: 'thirdPartyName',
      codeField: 'thirdPartyName',
      nameField: 'thirdPartyName'
    },
    formProps: {
      idField: Constants.OilSample.billingThirdParty.field,
      codeField: Constants.OilSample.billingThirdParty.field,
      nameField: Constants.OilSample.billingThirdParty.field
    },
    isServerSide: true,
    serverSearchKey: 'ThirdPartySearchFieldQuery',
    searchOnOpen: true
  },
  UnitType: {
    store: 'UnitType',
    lookups: {
      idField: Constants.UnitType.unitTypeName.field,
      codeField: Constants.UnitType.unitTypeName.field,
      nameField: Constants.UnitType.unitTypeName.field
    },
    formProps: {
      idField: 'unitTypeName',
      codeField: 'unitTypeName',
      nameField: 'unitTypeName'
    },
    isServerSide: true,
    serverSearchKey: 'UnitTypeSearchFieldQuery',
    searchOnOpen: true
  },
  MakeUpOilUnitOfMeasure: {
    store: 'UnitOfMeasure',
    lookups: {
      idField: Constants.UnitOfMeasure.unitOfMeasureID.field,
      codeField: Constants.UnitOfMeasure.unitOfMeasureCode.field,
      nameField: Constants.UnitOfMeasure.unitOfMeasureName.field
    },
    formProps: {
      idField: Constants.OilSample.makeUpOilUnitOfMeasureId.field,
      codeField: Constants.OilSample.makeUpOilUnitOfMeasureName.field,
      nameField: Constants.OilSample.makeUpOilUnitOfMeasureName.field
    },
    typeCode: 'fluid'
  },
  MeterReadingUnitOfMeasure: {
    store: 'UnitOfMeasure',
    lookups: {
      idField: Constants.UnitOfMeasure.unitOfMeasureID.field,
      codeField: Constants.UnitOfMeasure.unitOfMeasureCode.field,
      nameField: Constants.UnitOfMeasure.unitOfMeasureName.field
    },
    formProps: {
      idField: Constants.OilSample.meterReadingUnitOfMeasureId.field,
      codeField: Constants.OilSample.meterReadingUnitOfMeasureName.field,
      nameField: Constants.OilSample.meterReadingUnitOfMeasureName.field
    },
    typeCode: 'reading'
  },
  MilesOrHoursOnSampleUnitOfMeasure: {
    store: 'UnitOfMeasure',
    lookups: {
      idField: Constants.UnitOfMeasure.unitOfMeasureID.field,
      codeField: Constants.UnitOfMeasure.unitOfMeasureCode.field,
      nameField: Constants.UnitOfMeasure.unitOfMeasureName.field
    },
    formProps: {
      idField: Constants.OilSample.milesOrHoursOnSampleUnitOfMeasureId.field,
      codeField: Constants.OilSample.milesOrHoursOnSampleUnitOfMeasureName.field,
      nameField: Constants.OilSample.milesOrHoursOnSampleUnitOfMeasureName.field
    },
    typeCode: 'reading'
  },
  WaterUnitOfMeasure: {
    store: 'UnitOfMeasure',
    lookups: {
      idField: Constants.UnitOfMeasure.unitOfMeasureID.field,
      codeField: Constants.UnitOfMeasure.unitOfMeasureName.field,
      nameField: Constants.UnitOfMeasure.unitOfMeasureName.field
    },
    formProps: {
      idField: Constants.OilSample.waterUnitOfMeasureId.field,
      codeField: Constants.OilSample.waterUnitOfMeasureName.field,
      nameField: Constants.OilSample.waterUnitOfMeasureName.field
    },
    typeCode: 'water'
  },
  Unit: {
    store: 'Unit',
    lookups: {
      idField: Constants.Unit.unitId.field,
      codeField: Constants.Unit.unitName.field,
      nameField: Constants.Unit.unitName.field
    },
    formProps: {
      idField: Constants.OilSample.unitId.field,
      codeField: Constants.OilSample.unitName.field,
      nameField: Constants.OilSample.unitName.field
    },
    otherMappedProps: {
      [Constants.Unit.manufacturerModelName.field]: 'manufacturerModelName',
      [Constants.Unit.unitTypeName.field]: 'unitTypeName',
      [Constants.OilSample.makeUpOilUnitOfMeasureId.field]: Constants.Unit.defaultFluidUnitOfMeasureId.field,
      [Constants.OilSample.makeUpOilUnitOfMeasureName.field]: Constants.Unit.defaultFluidUnitOfMeasureName.field,
      [Constants.OilSample.meterReadingUnitOfMeasureId.field]: Constants.Unit.defaultReadingUnitOfMeasureId.field,
      [Constants.OilSample.meterReadingUnitOfMeasureName.field]: Constants.Unit.defaultReadingUnitOfMeasureName.field,
      [Constants.OilSample.milesOrHoursOnSampleUnitOfMeasureId.field]: Constants.Unit.defaultReadingUnitOfMeasureId.field,
      [Constants.OilSample.milesOrHoursOnSampleUnitOfMeasureName.field]:
        Constants.Unit.defaultReadingUnitOfMeasureName.field,
      [Constants.OilSample.fluidId.field]: Constants.Unit.defaultFluidId.field,
      [Constants.OilSample.fluidName.field]: Constants.Unit.defaultFluidName.field,
      [Constants.OilSample.fluidCode.field]: Constants.Unit.defaultFluidCode.field,
      [Constants.OilSample.fluidKeywords.field]: Constants.Unit.defaultFluidKeywords.field,
      [Constants.OilSample.fluidSearchField.field]: Constants.Unit.defaultFluidSearchField.field
    },
    dependsOn: 'Customer',
    searchKey: 'CustomerIdQuery',
    serverIdKey: 'UnitIdQuery',
    serverIdOperator: 'UnitIdOperator',
    getSelectedItemServerSide: true
  },
  Severity: { store: 'Severity' }
};
